module.exports = require("@material-ui/icons/Map");